import { render, staticRenderFns } from "./WCategorySelect.vue?vue&type=template&id=d0ebf76c&"
import script from "./WCategorySelect.vue?vue&type=script&lang=js&"
export * from "./WCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./WCategorySelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports